import React, { Component } from "react";
import FilterActiveIcon from "../../../icons/filteractiveicon";
import FilterIcon from "../../../icons/filtericon";
//moment import
import moment from "moment-timezone";
//Service import
import service from "../../../services";

//Loader import
import Loader from "../../loader";

//Redux Connect
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActCreators } from "../../../redux/bindActionCretor";
import EditIcon from "../../../icons/EditIcon";

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(ActCreators, dispatch);
};
let sub;
let statusFilterList = [];

class ProductList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loaderFlag: false,
            getAllProductCouponListDetails: [],
            getAllProductCouponListtotaldocs: [],
            offset: 0,
            perPage: 20,
            currentPage: 1,
            statusArray: [
                { assign: "Live", list: 1, value: false },
                { assign: "Disable", list: 2, value: false },
            ],
            data: [
                {
                    label: "product list",
                    Content: "This is content for Tab 1",
                },
            ],
        };
        this.apiserve = new service();
    }

    componentDidMount = async () => {
        this.getAllProductCouponList();
        this.getAllProductCouponEvent();
        this.setState({
            loaderFlag: true,
        });
    };
    componentWillUnmount = () => {
        sub.unsubscribe();
    };

    getAllProductCouponEvent = () => {
        sub = this.apiserve.getevent().subscribe((response) => {
            switch (response.event) {
                case "ticketCms|storeProducts|getList":
                    this.setState(
                        {
                            getAllProductCouponListDetails: response.data,
                            getAllProductCouponListtotaldocs: response.data.docs,
                        },
                        () => {
                            this.setState({
                                loaderFlag: false,
                                pageCount: Math.ceil(response.data.totalDocs / this.state.perPage),
                            });
                        }
                    );
                    break;
            }
        });
    };

    getAllProductCouponList = () => {
        this.apiserve.sendevent("ticketCms|storeProducts|getList", {});
    };
    editTalkEventListData = (item) => {
        this.props.StoreProductEditList(item);
        this.props.history.push({ pathname: "/product-store-detail" });
    };
    StatusFilter = (e, selectedInex, isClearStatusType = false) => {
        let index = selectedInex;
        let event = e && e.target && e.target.checked;
        let approvePassList = [...this.state.statusArray];
        approvePassList.forEach((key, i) => {
            if (i === index) {
                approvePassList[i].value = event;
            }
            if (isClearStatusType) {
                approvePassList[i].value = false;
                statusFilterList = [];
            }
        });
        
        this.setState({
            ...this.state,
            statusArray: approvePassList,
            currentPage: 0,
        }, () => {
            if (event) {
                if (index !== null) {
                    statusFilterList = [...statusFilterList, this.state.statusArray[index].list,];
                }
            } else {
                if (index !== null) {
                    let tempArray = statusFilterList.filter((d) => d !== this.state.statusArray[index].list);
                    statusFilterList = tempArray;
                }
            }
            this.getFilmFilter(
                this.state.offset,
                this.state.perPage,
                isClearStatusType
            );
        }
        );
    };

    getFilmFilter = (skip, limit, isClearStatusType) => {
        let data = {
            page: 1,
            limit: limit,
        };

        

        if (!isClearStatusType && statusFilterList && statusFilterList.length) {
            data.active = statusFilterList;
        }

        this.apiserve.sendevent("ticketCms|storeProducts|getList", data);
    };

    render() {
        const { getAllProductCouponListtotaldocs, statusArray } = this.state;
        return (
            <>
                <table>
                    <thead>
                        <tr>
                            <th></th>
                            <th>Variant</th>
                            <th>Price</th>
                            <th>Created Date (MT)</th>
                            <th>Last Updated Date (MT)</th>
                            {/* <th>Status</th> */}
                            <th></th>
                            <th>
                                <span className="d_flex d_flex_align_center">
                                    Status
                                    {statusFilterList && statusFilterList.length ? (
                                        <FilterActiveIcon />
                                    ) : (
                                        <FilterIcon />
                                    )}
                                </span>
                                <div className="tabelData_popup">
                                    <form>
                                        <div className="customCheck">
                                            <div className="customCheckBox clear_all_popup d_flex d_flex_justify_spacebt">
                                                <p className="link" onClick={() => this.StatusFilter(null, null, true)} > Clear All </p>
                                            </div>
                                            <div className="customCheckBox">
                                                {statusArray.map((item, i) => (
                                                    <div className="customCheckBox">
                                                        <input
                                                            type="checkbox"
                                                            id={"status1" + item.list}
                                                            name={"status1" + item.list}
                                                            value={item.list ? true : false}
                                                            checked={item.value ? true : false}
                                                            onClick={(e) => this.StatusFilter(e, i)}
                                                        />
                                                        <label htmlFor={"status1" + item.list}> {item.assign} </label>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {getAllProductCouponListtotaldocs &&
                            getAllProductCouponListtotaldocs.map((item, i) => (
                                <>
                                    <tr className={item.variants.active === 2 ? "disable" : ""} >
                                        <td> <strong>{item.name}</strong> </td>
                                        <td> <p>{item.variants.name}</p> </td>
                                        <td> <p>${item.variants.price}</p> </td>
                                        <td> <p>{moment.tz(item.createdAt, "US/Mountain").format("MM/DD/YYYY")}</p> </td>
                                        <td> <p>{moment.tz(item.updatedAt, "US/Mountain").format("MM/DD/YYYY")}</p> </td>
                                        {/* <td> {item.globalSoldOut ? 'Sold Out' : 'On Sale'} </td> */}
                                        <td> <span className="pointer" onClick={() => this.editTalkEventListData(item)}><EditIcon /></span> </td>
                                        <td> <p> {item.variants.active === 1 ? "Live" : item.variants.active === 2 ? "Disabled" : ""} </p> </td>
                                    </tr>
                                </>
                            ))}
                    </tbody>
                </table>
                {/* Loader */}
                {this.state.loaderFlag ? <Loader /> : ""}
            </>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductList);
